import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

type Option = { label: string; value: any };

const SingleSelectFilter = ({
  options,
  value,
  onChange,
  label = "Filter By Status",
}: {
  options: Option[];
  value: any;
  onChange: (value: any) => void;
  label?: string;
}) => {
  const selectedIndex = options.findIndex((o) => o.value === value);
  // index <= 0 → the default "all" tab → render as the empty/placeholder state
  const isDefault = selectedIndex <= 0;
  const selectValue = isDefault ? "" : String(selectedIndex);

  return (
    <FormControl sx={{ m: 1, width: 300, flexShrink: 0 }}>
      {isDefault && (
        <InputLabel
          style={{
            position: "absolute",
            top: "10px",
            left: "20px",
            color: "gray",
          }}
          id="single-select-filter-label"
        >
          {label}
        </InputLabel>
      )}
      <Select
        labelId="single-select-filter-label"
        displayEmpty
        value={selectValue}
        onChange={(e) => {
          const idx = e.target.value === "" ? 0 : Number(e.target.value);
          onChange(options[idx]?.value);
        }}
      >
        <MenuItem value="" sx={{ display: "none" }} />
        {options.map((opt, idx) => (
          <MenuItem key={idx} value={String(idx)}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SingleSelectFilter;
